export const endpoints = {
  getRecognitionReport: () => '/dashboard/recognitions/generate-report',
  generateThankYouMessagesReport: () => '/dashboard/reports/generate/thank-you',
  generateOrderReport: () => '/dashboard/reports/generate/order',
  getRecognitionThankYouMessageReport: () => '/dashboard/recognitions/thank-you-messages',

  sendAutomationReport: '/dashboard/reports/generate/automation',
  generateRecognitionReport: ({ id } = {}) => `/dashboard/reports/generate/recognition/${id}`,
  generateThankYouReport: '/dashboard/reports/generate/thank-you'
};
